import { Box, Button, Center, Flex, Icon, Text } from "@chakra-ui/react";
import { Header } from "layouts/LayoutDefault/Header";
import FormValidacao from "pages/Auth/Servicos/ValidadorDocumentos/FormValidacao";
import InfoDocumento from "pages/Auth/Servicos/ValidadorDocumentos/InfoDocumento";
import React, { useState } from "react";
import { FaFileExcel } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTypedSelector } from "store/hooks";

export const ValidadorDocumentos: React.FC = () => {
  const [isExpired, setIsExpired] = useState(false);

  const { successPayload } = useTypedSelector(
    (state) => state.servicos.validarDocumento
  );
  const navigate = useNavigate();
  const goToHome = () => {
    navigate("/servicos");
  };

  const goBack = () => {
    setIsExpired(false);
  };

  return (
    <Flex h="full" direction="column">
      <Header />
      <Flex
        flex={1}
        pt="14"
        direction="column"
        justifyContent="space-between"
        bgColor="#f8f8f8"
      >
        {isExpired && (
          <Center flexDir="column" gap={4}>
            <Icon as={FaFileExcel} />
            <Text>
              QR Code expirado. Por favor, emita um novo documento atualizado.
            </Text>
            <Button variant="ghost" onClick={goBack}>
              Tentar outro código
            </Button>
            <Button onClick={goToHome}>Ir para tela inicial</Button>
          </Center>
        )}
        {!isExpired && !successPayload && (
          <FormValidacao updateIsExpired={setIsExpired} />
        )}
        {!isExpired && successPayload && (
          <InfoDocumento documento={successPayload} />
        )}
        <Box w="full" bgColor="white" fontSize="sm" textAlign="center" py="2">
          Sistema de Informações Territoriais - EGL Engenharia
        </Box>
      </Flex>
    </Flex>
  );
};
